import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getHistory = createAsyncThunk('userAccount/getHistory', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getUserHistory();
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const changeUserPassword = createAsyncThunk('userAccount/changeUserPassword', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.changeUserPassword(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
export const changeProfile = createAsyncThunk('userAccount/changeProfile', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.changeProfile(payload);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
